<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="6" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="light">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">Job-Wise Profit & Loss (Tally)</h5>
          </b-col>
          <b-col md="2">

            <h5>
              <small v-if="!isLoading">{{ totalUniqueJobs }} Unique Jobs</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right ml-1 mt-1" 
              :variant="Filter.dateRange.startDate || Filter.dateRange.endDate ? 'outline-danger' : 'outline-primary'" 
              @click="visible = !visible" 
              style="font-size: 0.675rem">
              {{ Filter.dateRange.startDate || Filter.dateRange.endDate ? "Filter ON" : "Filter OFF" }}
            </b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getAssignmentData.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel'" @click="exportJobWiseReport()" size="sm"
              variant="warning" style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small></b-spinner>
            </b-button>
          </b-col>

          <b-col cols="6">
            <div>
              <b-pagination limit="5" :total-rows="totalUniqueJobs" :per-page="pagination.perPage"
                v-model="pagination.currentPage" class="my-0 pull-right" @input="onPageChange" />
            </div>
          </b-col>
        </b-row>

        <div v-if="visible">
          <b-card>
            <b-row>
              <b-col md="3">
                <label>Date Range</label>
                <date-range-picker :always-show-calendars="false" v-model="Filter.dateRange" :locale-data="locale"
                  @update="fetchData"></date-range-picker>
              </b-col>
              <b-col md="3">
                <label>Common Filter</label>
                <b-form-input placeholder="Common Filter" v-model="Filter.commonFilter" @input="debounceSearch"></b-form-input>
              </b-col>
              <b-col md="3">
                <label>Invoice Filter</label>
                <b-form-input placeholder="Invoice Filter" v-model="Filter.invFilter" @input="debounceSearch"></b-form-input>
              </b-col>
              <b-col md="3">
                <label>Job No Filter</label>
                <b-form-input placeholder="Job No Filter" v-model="Filter.jobFilter" @input="debounceSearch"></b-form-input>
              </b-col>

              <b-col md="12" class="mt-2">
                <b-button size="sm" class="pull-right" @click="clearFilter" variant="outline-danger">Reset</b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :fields="getAssignmentFields" :items="getAssignmentData"
                class="table-background position-relative">
                
                <template slot="SN" slot-scope="row">
                  <span>{{ (pagination.currentPage - 1) * pagination.perPage + row.index + 1 }}</span>
                </template>

                <template slot="JOB_Details" slot-scope="row">
                  <span><strong>Job No:</strong> {{ row.item.JOBNO }}</span><br />
                  <span><strong>Date:</strong> {{ row.item.JOBDate }} ({{ row.item.MonthName }})</span><br />
                  <span><strong>Type:</strong> {{ row.item.JOBTYPE }}</span><br />
                  <span><strong>Booking:</strong> {{ row.item.BookingNo }}</span><br />
                  <span><strong>Client:</strong> {{ row.item.ClientName }}</span><br />
                  <span><strong>Branch:</strong> {{ row.item.Branch }}</span><br />
                  <span v-if="row.item.ContractNo && row.item.ContractNo !== 'NA'"><strong>Contract:</strong> {{ row.item.ContractNo }}</span><br/>
                  <TimelineModal v-if="row.item.JobId && $sessionsStorage.get('is_Mobile') != 'port'"
                  :PMC_title="'Timeline Summary Job No - ' + row.item.JOBNO"
                  :PMC_JOBID="(row.item.JobId)" :PMC_JOBNO="row.item.JOBNO"
                  :PMC_JOBDATE="row.item.JOBDate" :PMC_JOBTYPE="row.item.JOBTYPE" :PMC_AgentType="''"
                  :PMC_Client="row.item.ClientName" :PMC_Sline="row.item.ShippingLine" />
                   <Assignment-Summary v-if="$sessionsStorage.get('is_Mobile') != 'port' && row.item.JobId"
                    :title="'Shipment Summary Tracking - '" :assign_date="row.item.JOBDate"
                    :assign_job_type="row.item.JOBTYPE" :assign_raised_from="''" :assign_raised_by="''"
                    :fk_all_module_id="(row.item.JobId)" :jb_series="row.item.JOBNO" :fk_client_id="''"
                    :fk_pod_id="''" />
                  <InvExpSummary v-if="row.item.JobId"
                    :PMC_title="'Inv Exp Summary Job No - ' + row.item.JOBNO" :PMC_JOBID="(row.item.JobId)"
                    :PMC_JOBNO="row.item.JOBNO" :PMC_JOBDATE="row.item.JOBDate" :PMC_JOBTYPE="row.item.JOBTYPE"
                    :PMC_AgentType="''" :PMC_Client="row.item.ClientName" :PMC_Sline="row.item.ShippingLine" />
                  <ContainerSummary v-if="row.item.JobId"
                    :PMC_title="'Container Summary Job No - ' + row.item.JOBNO"
                    :PMC_JOBID="(row.item.JobId)" :PMC_JOBNO="row.item.JOBNO"
                    :PMC_JOBDATE="row.item.JOBDate" :PMC_JOBTYPE="row.item.JOBTYPE" :PMC_AgentType="''"
                    :PMC_Client="row.item.ClientName" :PMC_Sline="row.item.ShippingLine" />
                  <JobWisePaymentsDetails v-if="row.item.JobId"
                    :allModuleId="(row.item.JobId)" :JobNo="row.item.JOBNO" />
                  <RejectInvTallyBillSummary v-if="row.item.JobId" :PMC_title="'Invoice Rejection Log Summary Job No - ' +
                    row.item.JOBNO
                    " :PMC_JOBID="(row.item.JobId)" :PMC_JOBNO="row.item.JOBNO"
                    :PMC_JOBDATE="row.item.JOBDate" :PMC_JOBTYPE="row.item.JOBTYPE" :PMC_Client="row.item.ClientName"
                    :PMC_Sline="row.item.ShippingLine" />
                    <AssignmentSplitMergeSummary v-if="row.item.JobId"
                  :PMC_title="'Assignment Split/Merge/Move Summary Job No - ' + row.item.JOBNO"
                  :PMC_JOBID="(row.item.JobId)" :PMC_JOBNO="row.item.JOBNO"
                  :PMC_JOBDATE="row.item.JOBDate" :PMC_JOBTYPE="row.item.JOBTYPE" :PMC_AgentType="''"
                  :PMC_Client="row.item.ClientName" :PMC_Sline="row.item.ShippingLine" />
                  <!-- <BookingTrack
                  v-if="row.item.newfreightContainers && row.item.jobType.indexOf('FF') >= 0 && row.item.SubscriptionId"
                  :containerArr="row.item.newfreightContainers" :slineName="row.item.ShippingLine"
                  :clientName="row.item.ClientName"
                  :modal_title="`Container Movement Booking No: ${row.item.BookingNo} Job No - ${row.item.JOBNO} Client: ${row.item.ClientName}`"
                  :JOBNO="row.item.JOBNO" :shipment_id="Number(0)" :subscription_id="Number(0)"
                  :fk_sub_track_id="Number(0)" :fk_all_module_id="Number(row.item.JobId)"
                  :fk_booking_id="Number(row.item.fk_booking_id)" :fk_container_id="Number(0)" -->
                  <!-- :booking_number="row.item.BookingNo" :container_number="''" /> -->
                </template>

                <template slot="Status_Details" slot-scope="row">
                  <span><strong>FF/CC/TPT:</strong> {{ row.item.ffExInv }} / {{ row.item.ccExInv }} / {{ row.item.tptExInv }}</span><br />
                  <span><strong>Billing:</strong> {{ row.item.billingStatus }}</span><br />
                  <span><strong>Final Bill:</strong> {{ row.item.finalBill }}</span><br />
                  <span><strong>Tally Inv:</strong> {{ row.item.tallyExistInvoice || 'None' }}</span><br />
                  <span><strong>Overseas:</strong> {{ row.item.overseasBillingStatus }}</span>
                </template>

                <template slot="Freight_Details" slot-scope="row">
                  <span><strong>Overseas Income:</strong> {{ row.item.OceanFreightOverseasIncome }}</span><br />
                  <span><strong>Overseas Expense:</strong> {{ row.item.OceanFreightOverseasExpense }}</span><br />
                  <span><strong>Freight Charges:</strong> {{ row.item.OceanFreightCharges }}</span><br />
                  <span><strong>Expense Charges:</strong> {{ row.item.OceanFreightExpenseCharges }}</span><br />
                  <span><strong>Other Income:</strong> {{ row.item.OtherIncome }}</span><br />
                  <span><strong>Total Exp/Rev:</strong> {{ row.item.exp_inv_amt }} / {{ row.item.rev_inv_amt }}</span>
                </template>

                <template slot="Profit_Loss" slot-scope="row">
                  <div class="p-1" :style="{ backgroundColor: parseFloat(row.item.pl_profit) >= 0 ? '#e6fffa' : '#fff5f5', borderRadius: '4px' }">
                    <span><strong>Expense:</strong> {{ row.item.pl_expense }}</span><br />
                    <span><strong>Invoice:</strong> {{ row.item.pl_invoice }}</span><br />
                    <span :class="parseFloat(row.item.pl_profit) >= 0 ? 'text-success' : 'text-danger'">
                      <strong>Profit/Loss:</strong> {{ row.item.pl_profit }}
                    </span>
                  </div>
                </template>

              </b-table>
            </div>
            <div>
              <b-pagination limit="5" :total-rows="totalUniqueJobs" :per-page="pagination.perPage"
                v-model="pagination.currentPage" class="my-0 pull-right" @input="onPageChange" />
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import CustomLoader from "../common/customLoader.vue";
import DateRangePicker from "vue2-daterange-picker";
import UlipService from "../../services/UlipService.js";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import AssignmentSummary from "../common/assignmentSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import userBasedClient from "../common/userBasedClient.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";
import TimelineModal from "../common/TimelineModal.vue";

export default {
  name: "OceanFreightJobWiseProfitLoss",
  components: {
    CustomLoader,
    DateRangePicker,

    AssignmentSummary,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
    TimelineModal,
    BookingTrack,
    userBasedClient,
  },
  data() {
    return {
      isLoading: false,
      visible: false,
      ExcelBtnName: "Export As Excel",
      getAssignmentData: [],
      totalUniqueJobs: 0,
      getAssignmentFields: [
        { key: "SN", label: "SN" },
        { key: "JOB_Details", label: "Job Details" },
        { key: "Status_Details", label: "Status" },
        { key: "Freight_Details", label: "Freight Amounts" },
        { key: "Profit_Loss", label: "Profit & Loss" },
      ],
      pagination: {
        currentPage: 1,
        perPage: 50,
      },
      Filter: {
        jobFilter: "",
        invFilter: "",
        commonFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
      },
      debounce: null,
    };
  },
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (!(globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP"))) {
      this.$router.push({ path: "/dashboard" });
    } else {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      let payload = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.perPage,
        Filter: Object.assign({}, this.Filter, {
          dateRange: {
            startDate: this.Filter.dateRange.startDate ? new Date(this.Filter.dateRange.startDate).toISOString().split('T')[0] : "",
            endDate: this.Filter.dateRange.endDate ? new Date(this.Filter.dateRange.endDate).toISOString().split('T')[0] : "",
          }
        }),
        isAllNo: 0,
        generateExcel: 0,
      };

      UlipService.getJobWiseProfitLossForTally(payload)
        .then((response) => {
          const { data } = response;
          if (data.success) {
            this.getAssignmentData = data.data.getAssignmentData;
            this.totalUniqueJobs = data.data.totalUniqueJobs || data.pagination.total;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.error("Error fetching job-wise data:", err);
          this.isLoading = false;
        });
  },
    onPageChange() {
      this.fetchData();
    },
    debounceSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.pagination.currentPage = 1;
        this.fetchData();
      }, 800);
    },
    clearFilter() {
      this.Filter = {
        jobFilter: "",
        invFilter: "",
        commonFilter: "",
        dateRange: { startDate: "", endDate: "" },
      };
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    exportJobWiseReport() {
      this.ExcelBtnName = "Downloading...";
      let payload = {
        Filter: this.Filter,
        isAllNo: 1,
        generateExcel: 1,
      };
      UlipService.getJobWiseProfitLossForTally(payload, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `JobWiseProfitLoss_${new Date().getTime()}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.ExcelBtnName = "Export As Excel";
        })
        .catch((err) => {
          console.error("Excel export error:", err);
          this.ExcelBtnName = "Export As Excel";
        });
    },
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped>
.mainCardBG {
  border: none;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.table-responsive {
  border-radius: 8px;
  overflow: hidden;
}
.text-success { color: #2f855a !important; }
.text-danger { color: #c53030 !important; }
</style>



// WEBPACK FOOTER //
// OceanFreightJobWiseProfitLoss.vue?15a63771